(function () {
    'use strict';
    // DO NOT EDIT THIS FILE, EDIT THE GULP TASK NGCONSTANT SETTINGS INSTEAD WHICH GENERATES THIS FILE
    angular
        .module('bozorakaAdminApp')
        .constant('VERSION', "0.2.45-SNAPSHOT")
        .constant('DEBUG_INFO_ENABLED', false)
;
})();
